/* eslint-disable react/destructuring-assignment */
import { useContext, useMemo } from 'react';
import { getTransactionTrackerConfigFromProps } from '../helpers';
import type { MoonPayTransactionTrackerProps } from '../types';
import { MoonPayContext } from './MoonPayProvider';
import { MoonPayWidget } from './MoonPayWidget';

export function MoonPayTransactionTrackerWidget(
  props: MoonPayTransactionTrackerProps,
) {
  const { apiKey, environment } = useContext(MoonPayContext);

  const config = useMemo(
    () =>
      getTransactionTrackerConfigFromProps({
        props,
        apiKey,
        environment,
        debug: false,
        signature: '',
      }),
    [props, apiKey, environment],
  );

  return (
    <MoonPayWidget
      config={config}
      visible={props.visible}
      onUrlSignatureRequested={props.onUrlSignatureRequested}
      className={props.className}
      style={props.style}
    />
  );
}
